type IconAccountBalanceProps = {
    className?: string;
};

export function IconAccountBalance(props: IconAccountBalanceProps) {
    const { className = '' } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={true}
            className={`${className}`}
        >
            <mask
                id="mask0_6947_18978"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6947_18978)">
                <path
                    d="M5 17V10H7V17H5ZM11 17V10H13V17H11ZM2 21V19H22V21H2ZM17 17V10H19V17H17ZM2 8V6L12 1L22 6V8H2ZM6.45 6H17.55L12 3.25L6.45 6Z"
                    fill="black"
                />
            </g>
        </svg>
    );
}

export default IconAccountBalance;
